import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";
import { fetchAllCompanies } from "../../store/slices/userSlice";
import company_1 from '../../assets/images/company_1.png';
import close_icon from '../../assets/images/close_icon.svg';

const CompanysPayrollPopup = ({ show, onHide }) => {
  const dispatch = useAppDispatch();

  const COMPANY_PAYROLL_POPUP_PAGE_KEY = "companyListPayrollPopup";

  const { user } = useAppSelector((s) => s.user);

  const companyList = useAppSelector((s) => s.user.listDataByKey[COMPANY_PAYROLL_POPUP_PAGE_KEY] || []);

  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "";

  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const wrapperRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleItemClick = (e, id) => {
    e.preventDefault();
    setSelectedItems(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  // 2. New function to handle deselection from the "pills"
  const handleDeselect = (id) => {
    setSelectedItems(prev => prev.filter(item => item !== id));
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (!show) {
      setIsOpen(false);
      setSelectedItems([]);
    } else {
      const clientId = user?.role === "Client" ? user.id : undefined;
      dispatch(fetchAllCompanies({ clientId, key: COMPANY_PAYROLL_POPUP_PAGE_KEY }));
    }
  }, [show, dispatch, user]);

  return (
    <Modal show={show} onHide={onHide} centered className='companys_payroll_popup'>
      <Modal.Header closeButton>
        <Modal.Title>Please Select Company</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='payroll_multi_select_container'>
          <div className='payroll_multi_select_input' ref={wrapperRef}>
            <a href='#' className='multi_select_input' onClick={toggleDropdown}>
              Select Companies
            </a>

            {isOpen && (
              <ul className='companys_list'>
                {companyList?.map((company) => {
                  const compId = company.id || company._id;
                  const img = company.logo ? BASE_URL + company.logo : company_1;
                  return (
                    <li key={compId}>
                      <a
                        href='#'
                        className={selectedItems.includes(compId) ? 'active' : ''}
                        onClick={(e) => handleItemClick(e, compId)}
                      >
                        <div className='company_img'><img src={img} alt={company.name} /></div>
                        {company.name}
                      </a>
                    </li>
                  )
                })}
              </ul>
            )}
          </div>

          {/* 3. New section to display selected companies */}
          <div className='selected_companies_display d-flex flex-wrap'>
            {selectedItems.map(id => {
              const company = companyList?.find(c => (c.id || c._id) === id);
              if (!company) return null;
              const img = company.logo ? BASE_URL + company.logo : company_1;

              return (
                <div key={id} className='selected_company_item'>
                  <div className='company_img'><img src={img} alt={company.name} /></div>
                  <span>{company.name}</span>
                  <img
                    src={close_icon}
                    alt="Deselect"
                    className='close_icon'
                    onClick={() => handleDeselect(id)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} className='btn_cancel my-0'>
          Cancel
        </Button>
        <Button
          as={Link}
          to="/SelectedPayroll"
          state={{ selectedCompanies: selectedItems }}
          variant="primary"
          className='btn_primary my-0 border-0'
          disabled={selectedItems.length === 0 || selectedItems.some(id => {
            const company = companyList?.find(c => (c.id || c._id) === id);
            return company && company.isActive === false;
          })}
        >
          Apply
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompanysPayrollPopup;
